module.exports = __webpack_public_path__ + "img/img3.3a7f6494.png";